module.exports = __webpack_public_path__ + "img/inst-modal-17.aedd6c7c.png";